import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class companyService extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/company');
    }

    getAppointmentCategories(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/company/appointment-categories`);
      }

    addActivity(body : any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/company/activity-type`, body);
    }

    updateActivity(body:any,id): Observable<any> {
        return this.http.patch(`${environment.apiUrl}/company/activity-type/${id}`, body);
    }

    addReason(body:any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/company/lost-reason`, body);
    }

    updateToogles(body : any): Observable<any> {
        return this.http.patch(`${environment.apiUrl}/company/updateToogles/${body.type_id}`, body);
    }

    updateActivitySequence(body: any): Observable<any> {
        return this.http.patch(`${environment.apiUrl}/company/activity-type-sequence`, body);
    }

    updateReason(body:any): Observable<any> {
        return this.http.patch(`${environment.apiUrl}/company/reason/${body.id}`, body);
    }

    importLead(file: File,considerAsNewLead:boolean,skipDuplicates:boolean): Observable<any> {
        // Create a FormData object to send the file
        const formData = new FormData();
        formData.append('exelFile', file)
        formData.append('considerAsNewLead', considerAsNewLead.toString());
        formData.append('skipDuplicates', skipDuplicates.toString());
        
        // Send the file to the import-lead endpoint
        return this.http.post(`${environment.apiUrl}/company/import-lead`, formData);
    }


    getActivitySubcategories(categoryId: number): Observable<any> {
        return this.http.get(`${environment.apiUrl}/subcategory/activity-subcategories/${categoryId}`);
      }
    
      createActivitySubcategory(data: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/subcategory/activity-subcategory`, data);
      }
    
      updateActivitySubcategory(id: number, data: any): Observable<any> {
        return this.http.put(`${environment.apiUrl}/subcategory/activity-subcategory/${id}`, data);
      }
    
      deleteActivitySubcategory(id: number): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/subcategory/activity-subcategory/${id}`);
      }

      getAllActivitySubcategories(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/subcategory/activity-subcategories`);
      }


      getAllOutcomes() {
        return this.http.get(`${environment.apiUrl}/outcome/outcomes`);
      }
      
      getOutcomesForActivityTypes(activityTypeIds: number[]) {
        const ids = activityTypeIds.join(',');
        return this.http.get(`${environment.apiUrl}/outcome/activity-types/${ids}/outcomes`);
      }
      
      createOutcome(data: any) {
        return this.http.post(`${environment.apiUrl}/outcome/outcome`, data);
      }
      
      updateOutcome(id: number, data: any) {
        return this.http.put(`${environment.apiUrl}/outcome/outcome/${id}`, data);
      }
      
      deleteOutcome(id: number) {
        return this.http.delete(`${environment.apiUrl}/outcome/outcome/${id}`);
      }
      
      getActivityTypesWithOutcomes() {
        return this.http.get(`${environment.apiUrl}/outcome/activity-types-with-outcomes`);
      }
      
      getActivityTypeOutcomes(activityTypeId: number) {
        return this.http.get(`${environment.apiUrl}/outcome/activity-type/${activityTypeId}/outcomes`);
      }

      getActivityTypes() {
        return this.http.get(`${environment.apiUrl}/activity-type`); // Adjust endpoint as needed
      }

       // New method for updating call configuration
  updateCallConfiguration(data: any, companyId: number): Observable<any> {
    return this.http.put(`${environment.apiUrl}/company/call-configuration/${companyId}`, data);
  }

  getAll(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/company/all`);
  }

  updateLostReasonSequence(body: { previousIndex: number; currentIndex: number }) {
    return this.http.patch(`${environment.apiUrl}/company/lost-reason-sequence`, body);
  }
  

    // ── Webhook Subscriptions ──

    getWebhookSubscriptions(): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}/company/webhook-subscriptions`);
    }
  
    createWebhookSubscription(data: { event: string; target_url: string; active: boolean }): Observable<any> {
      return this.http.post<any>(`${environment.apiUrl}/company/webhook-subscription`, data);
    }
  
    updateWebhookSubscription(id: number, data: Partial<{ event: string; target_url: string; active: boolean }>): Observable<any> {
      return this.http.put<any>(`${environment.apiUrl}/company/webhook-subscription/${id}`, data);
    }
  
    deleteWebhookSubscription(id: number): Observable<any> {
      return this.http.delete<any>(`${environment.apiUrl}/company/webhook-subscription/${id}`);
    }
}
